/**
 * Companies Jaron struck from the contract dropdown (13019053631).
 * A job that already has one of them keeps it. New picks do not offer them.
 * Matching is on the name the menu shows, plus the short names already in code.
 */

const RETIRED_SHORT_NAMES = new Set(['ce', 'wildcat'])

const RETIRED_NAME_PARTS = ['caballero', 'wildcat', 'nevada power solutions']

export const isRetiredContractCompany = (company: {
  longName?: string
  shortName?: string
}): boolean => {
  const shortName = (company.shortName || '').trim().toLowerCase()
  if (RETIRED_SHORT_NAMES.has(shortName)) return true
  const longName = (company.longName || '').toLowerCase()
  return RETIRED_NAME_PARTS.some((part) => longName.includes(part))
}

export const contractCompaniesForPicker = <
  T extends { longName?: string; shortName?: string },
>(
  companies: readonly T[],
  currentShortName: string,
): T[] =>
  companies.filter(
    (company) =>
      !isRetiredContractCompany(company) ||
      company.shortName === currentShortName,
  )
